import React from 'react';

function PageNavigation({ currentPage, totalPages, onPageChange, pageNumbers }) {
  if (totalPages <= 1) return null;

  return (
    <div className="page-navigation">
      <button
        className="nav-button"
        onClick={() => onPageChange(Math.max(0, currentPage - 1))}
        disabled={currentPage === 0}
      >
        Anterior
      </button>
      <span className="page-indicator">
        Pagina {pageNumbers[currentPage]} de {pageNumbers[totalPages - 1]}
      </span>
      <button
        className="nav-button"
        onClick={() => onPageChange(Math.min(totalPages - 1, currentPage + 1))}
        disabled={currentPage === totalPages - 1}
      >
        Siguiente
      </button>

      <style>{`
        .page-navigation {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
          padding: 12px;
          background: var(--card-background);
          border-top: 1px solid var(--border-color);
        }

        .nav-button {
          padding: 8px 16px;
          background: var(--primary-color);
          color: white;
          border: none;
          border-radius: var(--border-radius);
          font-size: 14px;
          transition: background 0.2s;
        }

        .nav-button:hover:not(:disabled) {
          background: var(--primary-hover);
        }

        .nav-button:disabled {
          background: var(--border-color);
          cursor: not-allowed;
        }

        .page-indicator {
          font-size: 14px;
          color: var(--text-secondary);
        }
      `}</style>
    </div>
  );
}

export default PageNavigation;
